import { getSettingsCalendarStatusApi as generatedGetSettingsCalendarStatusApi } from '../generated/settingsCalendar/getSettingsCalendarStatus';

const getSettingsCalendarStatusApi = generatedGetSettingsCalendarStatusApi.enhanceEndpoints({
  endpoints: {
    getSettingsCalendarStatus: {
      providesTags: ['SettingsCalendar'],
    },
  },
});

export const { useGetSettingsCalendarStatusQuery } = getSettingsCalendarStatusApi;
